import { render } from "./STags.vue?vue&type=template&id=a50051ba&scoped=true&ts=true"
import script from "./STags.ts?vue&type=script&lang=ts"
export * from "./STags.ts?vue&type=script&lang=ts"

import "./STags.scss?vue&type=style&index=0&id=a50051ba&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50051ba"]])

export default __exports__